// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__c8L6B","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1Taya"};